<app-custom-modal customTitle="Designar ordenador de respaldo" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <div class="space-y-4">
        <p class="text-xs text-gray-500">
            Si se pierde la conexión a internet, solo este ordenador podrá generar documentos, tickets y compras. Ponle un nombre que lo identifique (por ejemplo, "Caja principal"). Esto se guarda solo en este navegador — si ya hay otro ordenador designado, tendrás que desmarcarlo manualmente en él.
        </p>

        @if (otherActiveDeviceName) {
        <p class="text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg p-2">
            Ahora mismo se detecta otro ordenador activo como dispositivo de respaldo: <strong>{{ otherActiveDeviceName }}</strong>.
        </p>
        }

        <input type="text" [formControl]="nameControl" placeholder="Nombre de este ordenador"
            class="w-full px-3 py-2.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-300" />

        @if (isThisDevice) {
        <button type="button" (click)="stopBeingDevice()"
            class="text-xs text-red-500 hover:text-red-600 underline">
            Este ordenador ya no debe ser el dispositivo de respaldo
        </button>
        }
    </div>
</app-custom-modal>
